import DeliveryDatePicker from "components/Date/DeliveryDatePicker"
import React, { Component, Fragment, useRef, useEffect, useState } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import htmr                                                                           from "htmr";
import {
  
  Col,
  FormField,
  FormInput,
  Form,
  Checkbox,
  Row,
} from "elemental-react16"
import { Header, Button, Modal, Dropdown,Table, Message, Image, Icon, Card, Radio } from "semantic-ui-react"
import shop from "shop/shop"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import moment from "moment"
import CartTotalMinimum                                          from "components/Cart/CartTotalMinimum"
import MinOrderFreeValue from "components/Cart/MinOrderFreeValue"
import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import DeliveryMessage from "components/Cart/DeliveryMessage"
window.moment = moment
import "style/DeliveryPage.scss"
import 'react-day-picker/lib/style.css';
import Responsive                                                from "react-responsive"


@observer
export default class DeliveryPage extends Component {
  
  state = {
    uploadedImages  : [],
    locations       : [],
    locationSelected: null,
    comment         : "",
    pickup          : false,
    modalOpened     : false,
    mainDeliverAddress: [],
    activeDeliverAddress: false,
    value           : "invoice",
    deliverMessage: "",
    tempAddressIndex: 0,
    tempAddress     : {
      mapid   : "0",
      name1   : "",
      name2   : "",
      name3   : "",
      street  : "",
      pcode   : "",
      city    : "",
      country : "",
      company : "",
      addition: "",
    }
  }
  
  handleAddressChoice = () => {
    const tempAddress = this.state.tempAddress
    const nextTempAddressIndex = this.state.tempAddressIndex + 1
    
    shop.cart.setAddress( { location: tempAddress } )
    
    this.setState( {
      locations       : [tempAddress, ...this.state.locations],
      locationSelected: tempAddress.mapid,
      modalOpened     : false,
      tempAddressIndex: nextTempAddressIndex,
      tempAddress     : {
        mapid   : `tempAddress${nextTempAddressIndex}`,
        company : "",
        name1   : "",
        name2   : "",
        name3   : "",
        street  : "",
        pcode   : "",
        city    : "",
        country : "",
        addition: "",
      }
    } )
  }
  
  toggleModal = ( toggle = false ) => {
    this.setState( { modalOpened: toggle } )
  }
  
  handleAddressFieldChange = ( evt ) => {
    const tempAddress = this.state.tempAddress
    tempAddress[ evt.target.name ] = evt.target.value
    this.setState( { tempAddress } )
  }
  
  handleLocationSelect = ( location ) => {
    console.log( `set`, location )
    this.setState( { locationSelected: location.mapid } )
    shop.cart.setAddress( { location } )
    shop.cart.handleDeliverProcess()
    console.log("shop.cart.data", shop.cart.data)
    shop.cart.setExtra( "deliveryMessage", shop.cart.getExtra( "deliveryMessage" ) )
    shop.cart.setExtra( "pickUp", false )
    this.setState( { pickup: false } )
  }
  
  handleOrderIdChange = ( event ) => {
    let manual_order_id = event.target.value
    this.setState( { manual_order_id } )
    shop.cart.setExtra( "manual_order_id", manual_order_id )
  }
  handleReferenceChange = ( event ) => {
    let referenceId = event.target.value
    this.setState( { referenceId } )
    shop.cart.setExtra( "referenceId", referenceId )
  }
  handleEmailChange = ( event ) => {
    let EmailUser = event.target.value
    this.setState( { EmailUser } )
    shop.cart.setExtra( "EmailUser", EmailUser )
  }
  handleUserCartChange = ( event ) => {
    let CartUser = event.target.value
    this.setState( { CartUser } )
    shop.cart.setExtra( "CartUser", CartUser )
  }
  
  handleCommentChange = ( event ) => {
    let comment = event.target.value
    this.setState( { comment } )
    shop.cart.setExtra( "comment", comment )
    shop.cart.setComment( { comment } )
    console.log("shop.cart.data", shop.cart.data)
  }
  
  handleDateChange = ( date ) => {
    let deliverdate = moment( date )
    if ( deliverdate.isValid() ) {
      deliverdate = deliverdate.format( "DD.MM.YYYY" )
      this.setState( { deliverdate } )
      shop.cart.setDeliverdate( { deliverdate } )
    } else {
      shop.cart.setDeliverdate( ({ deliverdate: "" }) )
      this.setState( { deliverdate: "" } )
    }
    
  }

  handlePickUpDateChange = ( date ) => {
    let weekend = (moment(date, "DD.MM.YYYY").format("dddd").startsWith("So") || moment(date, "DD.MM.YYYY").format("dddd").startsWith("Sa")) ? true : false;
    if(weekend){
      shop.toast("Abholung nur Mo-Fr möglich", "error");
      shop.cart.setExtra( "pickupdate", "" )
      this.setState( { pickupdate: "" } )
      return;
    }
    let pickupdate = moment( date )
    if ( pickupdate.isValid() ) {
      pickupdate = pickupdate.format( "DD.MM.YYYY" )
      this.setState( { pickupdate } )
      shop.cart.setExtra( "pickupdate", pickupdate )
    } else {
      shop.cart.setExtra( "pickupdate", "" )
      this.setState( { pickupdate: "" } )
    }
    
  }

  updateCart = ( { cart } ) => {
    let locationSelected = cart.data.deliveraddress && cart.data.deliveraddress.mapid
    if ( locationSelected ) {
      this.setState( { locationSelected } )
    }
    //shop.cart.handleDeliverProcess()
  }
  
  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    // let ok = checkCartSize()
    // ok = ok && checkMinCartValue()
    // if ( !ok ) return
    if ( shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid ) {
      let locationSelected = shop.cart.data.deliveraddress.mapid
      this.setState( { locationSelected } )
      this.setState( { value: "delivery" } )
    }
    console.log("shop.cart.data", shop.cart.data)
    if ( shop.cart.data.extras.pickUp && String(shop.cart.data.extras.pickUp) == "true") {
      this.setState( { pickup: true } )
      this.setState( { value: "pickup" } )
    }
    //console.log("value", this.state.value)
    
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        console.log( "LOCATIONS!", locations.length, { locations } )
        
        if ( locations.length < 1 ) {
          console.info( "Keine Versandadressen vorhanden" )
          return
        }
        if(shop.cart.data.deliveraddress.extras && shop.cart.data.deliveraddress.extras.AdditionalAddresses){
          //console.log("shop.cart.data.deliveraddress.extras.AdditionalAddresses",shop.cart.data.deliveraddress)
        }
        else{
          const activeDeliverAddress = locations.some(location => location.extras.haupt === "J");
          this.setState({ activeDeliverAddress });
          this.setState({ value: activeDeliverAddress ? "delivery" : "invoice" });
        }


        let locationSelected = this.state.locationSelected
        const shortlist = locations.slice( 0, 100 )
        this.setState( {
          locations,
          shortlist,
          locationSelected
        } )
      } )
      shop.cart.handleDeliverProcess()
      console.log("shop.cart.data", shop.cart.data)
      shop.cart.setExtra( "deliveryMessage", shop.cart.getExtra( "deliveryMessage" ) )
  }

  handlePickUp = async ( pickup ) => {
    await this.setState({ pickup: pickup === "pickup" ? true : false }, () => {
      console.log(`pickup`, this.state.pickup)
    });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
    await shop.cart.setExtra( "pickUp", this.state.pickup )
    console.log( `pickup`, this.state.pickup )
    shop.cart.handleDeliverProcess()
    console.log("shop.cart.data", shop.cart.data)
    shop.cart.setExtra( "deliveryMessage", shop.cart.getExtra( "deliveryMessage" ) )
  }

  handleChangeRadio = (e, { value }) => {
    this.setState({ value });
    if (value === "pickup") {
      this.handlePickUp( value );
      if (typeof window !== 'undefined') {
        const element = document.getElementById('my-section');
        console.log("element", element);
        if (!element) return;
        window.scroll({
          top: element.offsetTop - 20,
          behavior: 'smooth'
        });
      }
      setTimeout(() => {
      }, 100);
    }
    if (value === "invoice") {
      this.handleLocationSelect(false);
      this.handlePickUp( value );
    }
    if (value === "delivery") {
      this.handlePickUp( value );
      if (typeof window !== 'undefined') {
        const element = document.getElementById('my-section');
        console.log("element", element);
        if (!element) return;
        window.scroll({
          top: element.offsetTop - 20,
          behavior: 'smooth'
        });
      }
    }
  }
  
  render() {
    const { loading } = shop.cart
    let { uploadedImages, locations, shortlist, locationSelected, tempAddress, modalOpened, deliverMessage, pickup } = this.state
    const attachments = shop.cart.getExtra( "attachments" )
    const deliveryLocation = locations.filter( loc => loc.mapid === locationSelected )
    let { comment, deliveraddress, deliverdate, print_receipt, comment_internal } = shop.cart.data
    let { manual_order_id,referenceId, pickupdate, CartUser, EmailUser } = shop.cart.data.extras
    let billingAddress = shop.session.value || {}
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    const { hasDeliveryAddress } = shop.cart
    const getDateWithoutTime = (date) => {
      return {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate()
      };
    };
    let { sum } = shop.cart.data
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
    const MIN_ORDER_FREE_VALUE = Number( shop.config.MIN_ORDER_FREE_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (Number(sum) > shop.config.MIN_ORDER_VALUE)
		let aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || (Number(sum) > shop.config.MIN_ORDER_FREE_VALUE)
		let shippingCosts = sum <= 100 ? "9,95" : (sum >= 150 ? "0,00" : "7,95");
    //console.log("VERSANDKOSTEN?",shippingCosts, sum, MIN_ORDER_FREE_VALUE)
    //console.log("shop.cart.data.deliveraddress",shop.cart.data.deliveraddress, shop.session.value.extras)
    if(shop.session && shop.session.shopuser){
      if (pickup) {
        aboveMinFree = true;
        shippingCosts = "0,00"
      } else if ( shop.cart.data.extras && shop.cart.data.extras.deliveryEL == "EL" ) {
        aboveMinFree = true;
        shippingCosts = "0,00"
      } else {
        aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
        (Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || (shop.cart.data.extras && shop.cart.data.extras.deliveryTour && shop.cart.data.extras.deliveryTour !== "");
      }
      /*else {
        aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
        (Number(sum) >= shop.config.MIN_ORDER_FREE_VALUE) || 
        (shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.extras && shop.cart.data.deliveraddress.extras.tour &&
          (shop.cart.data.deliveraddress.extras.tour !== "" || 
          shop.cart.data.deliveraddress.extras.lieferart == "Abholung")) || 
        (Object.keys(shop.cart.data.deliveraddress).length === 0 && shop.session.value && shop.session.value.extras && shop.session.value.extras.tour &&
          (shop.session.value.extras.tour !== "" || 
          shop.session.value.extras.lieferart == "Abholung"));
      }*/
    }
    const myRef = useRef<HTMLElement | null>(null);


    return (
      <div className="pb5">
        {/*HEADER STATE*/}
        {this.props.children}
        <HeaderCheckout activeStep={1} isRequest={isRequest}/>
        
        <section className="container">
          
          <div className="row-title tl">
            <h2>{translate( "your data" )}</h2>
          </div>
          <Responsive maxWidth={789}>
            <table>
              <tbody>
                <tr>
                  <td className="bb b--black-20 pb2 v-top">
                  <span className="black-50">{translate( "Rechnungsadresse" )} </span>
                  <div className="pt3">
                <strong> {billingAddress.title}</strong> <br/>
                {billingAddress.street} <br/>
                {billingAddress.pcode} {billingAddress.city}<br/>
                {billingAddress.country}<br/>
                {billingAddress.email && <div>{billingAddress.email}</div>}
                {billingAddress.phone && <div>{billingAddress.phone}</div>}
                {/*billingAddress.extras && billingAddress.extras.bemerkung && billingAddress.extras.bemerkung != "" && <div>{billingAddress.extras.bemerkung}</div>*/}
              </div>
                    </td>
                  <td className="bb b--black-20 pb2 v-top">
                  <span className="black-50">{translate( "Lieferadresse" )} </span>
                  {<div className="pt3">
                {!hasDeliveryAddress && !pickup && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
                {pickup && <div className="b">{translate( "Abholung" )}</div>}
                {deliveraddress && !pickup && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                    <div className="pt3 f6">
                      {deliveraddress.email && <div>{deliveraddress.email}</div>}
                      {deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
                      {deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {htmr(deliveraddress.extras.bemerkung)}</div> }
                    </div>
                  </div>
                </div>}
              </div>}
              <div className="pt3">
              <Form>
                  <FormField>
                    <Radio
                      label="Lieferadresse wie Rechnungsadresse"
                      name="radioGroup"
                      value="invoice"
                      checked={this.state.value === "invoice"}
                      onChange={this.handleChangeRadio}
                    />
                  </FormField>
                  <FormField>
                    <Radio
                      label="Abweichende Lieferadresse"
                      name="radioGroup"
                      value="delivery"
                      checked={this.state.value === "delivery"}
                      onChange={this.handleChangeRadio}
                    />
                  </FormField>
                  <FormField>
                    <Radio
                      label="Selbstabholung (Hüser-van Zwoll Versandzentrum)"
                      name="radioGroup"
                      value="pickup"
                      checked={this.state.value === "pickup"}
                      onChange={this.handleChangeRadio}
                    />
                  </FormField>
                </Form>
              </div>
                    </td>
                </tr>
                <tr>
                  <td className="pt3">
                  <span className="black-50">{translate("payment")}</span>
                    </td>
                    <td className="pt3">
                    <span className="black-50">{translate("your comment")}</span>
                    </td>
                </tr>
                <tr>
                  <td className="pt3 pb3 bb b--black-20 v-top">
                  <strong>{shop.session.value.extras.zahlartext}</strong>
                  </td>
                  <td className="pt3 pb3 bb b--black-20 v-top">
                  <strong>{comment ? comment : "-"}</strong>
                  </td>
                </tr>
                </tbody>
            </table>
            <table>
              <tbody>
                <tr>
                  <td>
                  <div  className="justify-between bg-white pa3 VariantsPullDownCart ">
                <div className="pb3 black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price><br/></div>
                <table className="pb3">
                <colgroup>
                    <col width="85%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        {!aboveMinFree && !pickup && <div className="pb2 b">{translate("Kostenloser Versand erreicht in: ")}</div>}
                        {!aboveMinFree && !pickup && <div className="pb2 b">{translate("Lieferkosten: ")}</div>}
                        {(aboveMinFree || pickup) && <div className="pb2 b">{translate("Kostenloser Versand erreicht!")}</div>}
                    </td>
                    <td className="b tr">
                        {!aboveMinFree && !pickup && <Price>{MIN_ORDER_FREE_VALUE-sum}</Price>}<br/>
                        {!aboveMinFree && !pickup && <Fragment>{shippingCosts} &nbsp;EUR</Fragment>}</td>
                    </tr>
                    <tr>
                    <td>{!aboveMinFree && !pickup && <MinOrderFreeValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>

                <table>
                <colgroup>
                    <col width="15%"/>
                    <col width="70%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        <Image className="w-40 h-40" src={`/arrowdownright.png`}/>
                        </td>
                    <td>
                        {!aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht in: ")}</div>}
                        {aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht!")} </div>}
                    </td>
                    <td className="b tr">
                        {!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
                    </tr>
                    <tr>
                        <td></td>
                    <td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>
            </div>
                  </td>
                </tr>
              </tbody>
            </table>
            {<Table>
            <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{translate( "Name" )}<a style={{ color: 'red' }}>*</a></Table.HeaderCell>
                    <Table.HeaderCell>{translate( "E-Mail" )}<a style={{ color: 'red' }}>*</a></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>            
                    <FormField required label={<Fragment>{translate( "Name" )}<a style={{ color: 'red' }}>*</a></Fragment>} >
                      <FormInput required placeholder={translate( "Name" )}
                         value={CartUser}
                         onChange={this.handleUserCartChange}
                      />
                    </FormField>
                  </Table.Cell>
                  <Table.Cell>            <FormField label={<Fragment>{translate( "E-Mail" )}<a style={{ color: 'red' }}>*</a></Fragment>}>
              <FormInput placeholder={translate( "E-Mail" )}
                         value={EmailUser}
                         onChange={this.handleEmailChange}
                         onBlur={(event) => {
                          const value = event.target.value;
                          if (!value.includes('@') || !value.includes('.')) {
                            shop.toast(translate("Bitte geben Sie eine gültige E-Mail-Adresse ein"), "error");
                            shop.cart.setExtra("EmailUser", "");
                          }
                        }}
              />
            </FormField>  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>}
              {/*<div className="pt3">
                {!hasDeliveryAddress && !pickup && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
                {pickup && <div className="b">{translate( "Abholung" )}</div>}
                {deliveraddress && !pickup && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                    <div className="pt3 f6">
                      {deliveraddress.email && <div>{deliveraddress.email}</div>}
                      {deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
                      {deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {deliveraddress.extras.bemerkung}</div> }
                    </div>
                  </div>
                </div>}
              </div>*/}
            </Responsive>
            <Responsive minWidth={790}>
          <Row>
            <Col md="1/5" className=""><span className="black-50">{translate( "Rechnungsadresse" )}</span>
              <div className="pt3">
                <strong> {billingAddress.title}</strong> <br/>
                {billingAddress.street} <br/>
                {billingAddress.pcode} {billingAddress.city}<br/>
                {billingAddress.country}<br/>
                {billingAddress.email && <div>{billingAddress.email}</div>}
                {billingAddress.phone && <div>{billingAddress.phone}</div>}
                {/*billingAddress.extras && billingAddress.extras.bemerkung && billingAddress.extras.bemerkung != "" && <div>{billingAddress.extras.bemerkung}</div>*/}
              </div>
            </Col>
            <Col md="1/5" className=""><span className="black-50">{translate( "Lieferadresse" )} </span>


              {<div className="pt3">
                {!hasDeliveryAddress && !pickup && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
                {pickup && <div className="b">{translate( "Abholung" )}</div>}
                {deliveraddress && !pickup && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                    <div className="pt3 f6">
                      {deliveraddress.email && <div>{deliveraddress.email}</div>}
                      {deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
                      {deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {htmr(deliveraddress.extras.bemerkung)}</div> }
                    </div>
                  </div>
                </div>}
              </div>}

            </Col>
            <Col md="1/5" className="">
            <span className="black-50">{translate("Lieferung")}</span>
            <div className="pt3 bb b--black-20 mb2">
              <Form>
                  <FormField>
                    <Radio
                      label="Lieferadresse wie Rechnungsadresse"
                      name="radioGroup"
                      value="invoice"
                      checked={this.state.value === "invoice"}
                      onChange={this.handleChangeRadio}
                    />
                  </FormField>
                  <FormField>
                    <Radio
                      label="Abweichende Lieferadresse"
                      name="radioGroup"
                      value="delivery"
                      checked={this.state.value === "delivery"}
                      onChange={this.handleChangeRadio}
                    />
                  </FormField>
                  <FormField>
                    <Radio
                      label="Selbstabholung (Hüser-van Zwoll Versandzentrum)"
                      name="radioGroup"
                      value="pickup"
                      checked={this.state.value === "pickup"}
                      onChange={this.handleChangeRadio}
                    />
                  </FormField>
                </Form>
              </div>
            <span className="black-50">{translate("payment")}</span>
									<div className="pt3 pb2">
										{/*<Link className={"mr3"} to={"/cms/zahlungsbedingungen-2024/"}>
										<strong>{translate("Zahlung auf Rechnung")}</strong>
												</Link>*/}
										<strong>{shop.session.value.extras.zahlartext}</strong>
									</div>
									<div className="pt3 bt b--black-20">
										<span className="black-50">{translate("your comment")}</span>
											<div className="pt3">
												<strong>{comment ? comment : "-"}</strong>
											</div>
										
									</div>
								</Col>
            <Col md="2/5" className=""><span className="black-50 pb2">{translate( "Lieferhinweise" )} </span>
            <div  className="justify-between bg-white pa3 VariantsPullDownCart ">
                <div className="pb3 black-40">{translate("Ihr aktueller Bestellwert: ")}<Price>{sum}</Price><br/></div>
                <table className="pb3">
                <colgroup>
                    <col width="85%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        {!aboveMinFree && !pickup && <div className="pb2 b">{translate("Kostenloser Versand erreicht in: ")}</div>}
                        {!aboveMinFree && !pickup && <div className="pb2 b">{translate("Lieferkosten: ")}</div>}
                        {(aboveMinFree || pickup) && <div className="pb2 b">{translate("Kostenloser Versand erreicht!")}</div>}
                    </td>
                    <td className="b tr">
                        {!aboveMinFree && !pickup && <Price>{MIN_ORDER_FREE_VALUE-sum}</Price>}<br/>
                        {!aboveMinFree && !pickup && <Fragment>{shippingCosts} &nbsp;EUR</Fragment>}</td>
                    </tr>
                    <tr>
                    <td>{!aboveMinFree && !pickup && <MinOrderFreeValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>

                <table>
                <colgroup>
                    <col width="15%"/>
                    <col width="70%"/>
                    <col width="15%"/>
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                        <Image className="w-40 h-40" src={`/arrowdownright.png`}/>
                        </td>
                    <td>
                        {!aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht in: ")}</div>}
                        {aboveMin && <div className="pb2 b">{translate("Mindestbestellwert erreicht!")} </div>}
                    </td>
                    <td className="b tr">
                        {!aboveMin && <Price>{MIN_ORDER_VALUE-sum}</Price>}</td>
                    </tr>
                    <tr>
                        <td></td>
                    <td>{!aboveMin && <MinOrderValue sum={sum} />}</td>
                    </tr>
                </tbody>    
                </table>
            </div>
          {<form className={`AddressForm`}>
            <Table>
            <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{translate( "Bestellername" )}<a style={{ color: 'red' }}>*</a></Table.HeaderCell>
                    <Table.HeaderCell>{translate( "E-Mail Adresse" )}<a style={{ color: 'red' }}>*</a></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>            
                    <FormField required label={translate( "Bestellername" )} htmlFor="name1" >
                      <FormInput required placeholder={translate( "Bestellername" )} maxLength={50}  type="text" name="name1"
                         value={CartUser}
                         onChange={this.handleUserCartChange}
                      />
                    </FormField>
                  </Table.Cell>
                  <Table.Cell>            <FormField label={translate( "E-Mail Adresse" )}>
              <FormInput placeholder={translate( "E-Mail Adresse" )}
                         value={EmailUser}
                         onChange={this.handleEmailChange}
                         onBlur={(event) => {
                          const value = event.target.value;
                          if (!value.includes('@') || !value.includes('.')) {
                            shop.toast(translate("Bitte geben Sie eine gültige E-Mail-Adresse ein"), "error");
                            shop.cart.setExtra("EmailUser", "");
                          }
                        }}
              />
            </FormField>  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            </form>}
            </Col>
            {/*<Col md="1/5" className=""><span className="black-50">{translate( "payment" )} </span>*/}
            {/*  <div className="pt3">*/}
            {/*    <strong>wie vereinbart</strong>*/}
            {/*  </div>*/}
            {/*</Col>*/}
          </Row>
          </Responsive>
        </section>
      
       {/*!loading && <DeliveryMessage />*/}
       <section ref={myRef} id="my-section"></section>
        {this.state.value && this.state.value == "delivery" && <section className="container pt3 pb3">
          
          <div className="row-title tl">
            <h2>{translate( "your addresses" )}</h2>
          </div>
          {/*console.log("checkoutfeatures: ",shop.config.checkoutFeatures)}
          
          {/*shop.config.checkoutFeatures.temporaryDeliveryAddress && */}

          {shop.config.checkoutFeatures.temporaryDeliveryAddress &&
          <div className="pb3 pt2">
            <TemporaryAddress
              temporaryAddress={shop.cart.data.deliveraddress}
              onSubmit={async ( address ) => {
                await shop.cart.setDeliverAddress( address )
                await shop.cart.handleDeliverProcess()
                this.setState( { locationSelected: false } )
                shop.toast(translate("Lieferadresse ausgewählt") + ` – ${address.pcode} ${address.city}`, "success")
              }}/>
          </div>}
          
          {/*locations.length > 10 ? <div>
            <Adresses onChange={this.handleLocationSelect}
                      locations={shortlist}
                      deliveryLocation={deliveryLocation}
                      locationSelected={locationSelected}/>
            <div><Link to="/checkout/delivery/addresses">{translate("Alle Adressen anzeigen")}</Link>
            </div>
          </div> : */<Adresses 
                            onChange={this.handleLocationSelect}
                             locations={locations}
                             locationSelected={locationSelected}/>
          }
        
        </section>}
        {this.state.value && this.state.value == "pickup" && <section className="container pt3 pb3">
          <div className="row-title tl">
            <h2>{translate( "Abholung" )}</h2>
          </div>
          <table>
            <colgroup>
              <col width="55%"/>
              <col width="45%"/>
            </colgroup>
            <tbody>
            <tr>
                <td className="v-top">
                <FormField label={translate( "Abholung" )}
                         htmlFor="supported-controls-input">
                <DeliveryDatePicker  date={pickupdate} onChange={this.handlePickUpDateChange}/>
              </FormField>
                </td>
                <td className=" v-top pl2">
                {pickupdate && <FormField label={translate("Abholzeit")} htmlFor="pickup-time">
                <Dropdown style={{ minWidth: "200px", marginTop: "19px" }}
                  placeholder={translate("Abholzeit auswählen")}
                  fluid
                  selection
                  options={
                    Array.from({ length: moment(pickupdate, "DD.MM.YYYY").format("dddd").startsWith("Fr") ? 15 : 18 }, (_, i) => {
                    const isFriday = moment(pickupdate, "DD.MM.YYYY").format("dddd").startsWith("Fr");
                    const currentTime = new Date();
                    const currentHour = currentTime.getHours();
                    const currentMinutes = currentTime.getMinutes();
                    const formattedTime = `${currentHour}:${currentMinutes < 10 ? '0' : ''}${currentMinutes}`;
                    const d1 = getDateWithoutTime(new Date());
                    const d2 = getDateWithoutTime(moment(pickupdate, "DD.MM.YYYY").toDate());
                    //console.log(formattedTime);
                    //console.log("D1/D2",d1, d2);
                    let disabled = false;
                    if(d1.day == d2.day && d1.month == d2.month && d1.year == d2.year){
                      disabled = i - 3 < (currentHour - 8) * 2 || (i == (currentHour - 8) * 2 && currentMinutes > 30);
                    }
                    //console.log("isFriday", isFriday, moment(pickupdate, "DD.MM.YYYY").format("llll"));
                    if (isFriday && i > 14) return null;
                    const hour = Math.floor(i / 2) + 8;
                    const minutes = i % 2 === 0 ? "00" : "30";
                    return {
                      key: `${hour}:${minutes}`,
                      value: `${hour}:${minutes}`,
                      text: `${hour}:${minutes}`,
                      disabled: disabled
                    };
                  })}
                  onChange={(e, { value }) => {
                    this.setState({ pickupTime: value });
                    shop.cart.setExtra("pickupTime", value);
                  }}
                />
              </FormField>}
              {pickupdate && <p>
                Driburger Straße 14 <br/>
                  33649 Bielefeld <br/>
                  DE <br/><br/>
                  Telefon: 0521 68427<br/><br/>
                  Abholzeiten: <br/>
                  Mo –  Do: 8:00 – 16:30 Uhr <br/>
                  Fr: 8:00 – 15:00 Uhr 
                  </p>}
                </td>           
              </tr>
              </tbody>
          </table>

          </section>}
        
        {<section className="container">
          <Row>
            <Col sm="2/3">
              <FormField label={translate( "comment" )}
                         htmlFor="supported-controls-input">
                <FormInput placeholder={translate( "commentPlaceholder" )}
                           value={comment}
                           onChange={this.handleCommentChange}
                           multiline/>
              </FormField>
            </Col>
          </Row>
        </section>}
        
        
        {/*        <section className="container">
          <div className="mw6">
        <FormField label={translate( "order number" )}>
              <FormInput placeholder={translate( "order number" )}
                         value={manual_order_id}
                         onChange={this.handleOrderIdChange}
              />
            </FormField>
            <FormField label={translate( "Referenznummer" )}>
              <FormInput placeholder={translate( "Referenznummer" )}
                         value={manual_order_id}
                         onChange={this.handleReferenceChange}
              />
            </FormField>
            
                      </div>
        </section>*/}
        
        {/*DELIVERY DATE SUGGESTION*/}
        {(shop.config.checkoutFeatures.deliverdate || shop.config.plugin.deliverdate) &&
        <section className="container">
          {/*COMMENT WITH UPLOAD */}
          {/*NORMAL COMMENT*/}
          
          <Row>
            <Col sm="2/3">
              <FormField label={translate( "delivery after" )}
                         htmlFor="supported-controls-input">
                <DeliveryDatePicker date={deliverdate} onChange={this.handleDateChange}/>
              </FormField>
            </Col>
          </Row>
        </section>
        }
        
        
        {/*ONLY FOR VERTRIEBSACCOUNTS*/}
        {(shop.session.handId && !shop.config.hideAddtionalCheckoutMetaForPowerUsers) && <div className="pt3">
          <section className="container">
            <div className="row-title tl">
              <h2>{translate( "back office" )}</h2>
            </div>
            <Row>
         
              <Col sm="1/2">
                <FormField label={translate( "Belegausdruck/Innendienst" )}
                           htmlFor="supported-controls-input">
                  <FormInput placeholder={translate( "Belegausdruck/Innendienst" )}
                             value={print_receipt}
                             onChange={event => {
                               let print_receipt = event.target.value
                               shop.cart.setExtra( "print_receipt", print_receipt )
                             }}
                             multiline/>
                </FormField>
              </Col>
            </Row>
          </section>
        </div>}
        
        <section className="pa2 mb4 ">
          <div className="container">
            <Row>
              <Col xs="1/2"
                   className="tl fl checkout-control">
                <Link to={{ pathname: "..", search: this.props.location.search }}>
                  <Button>
                    <i className="icon-angle-left"/>
                    {translate( "Zurück" )}
                  </Button>
                </Link>
              </Col>
              
              { <Col xs="1/2"
                   className="tr fr checkout-control">

                  <Button 
                   onClick={() => {shop.cart.setExtra( "pickUp", this.state.pickup ); this.props.history.push( "/checkout/confirmation" )}}
                   disabled={ !CartUser || !EmailUser }
                   primary>
                    {translate( "WeiterShoppingCart" )}
                    <i className="icon-angle-right"/>
                  </Button>
              </Col>}
            </Row>
          </div>
        </section>
      </div>
    )
  }
}

const Adress = ( { location, handleSelect, isSelected } ) => {
  useEffect(() => {
    if (location.extras && location.extras.haupt === "J" ) {
      handleSelect(location);
    }
  }, [location, handleSelect]);

  return (
    <div >
      <div className="bb b--black-20 pa2 black-70">{location.mapid.indexOf( "tempAddress" ) !== -1 && "Eingegebene"} {translate( "Lieferadresse" )}</div>
      <div className="pa2 pt3">{location.company}
      <b>{location.name1}</b><br/> {location.name2} <br/>{location.name3}<br/>
      {location.street} <br/>
      {location.addition} <br/>
      {location.pcode} {location.city}<br/>
      {location.country}<br/>
      {location.gln}
      {location.extras && <React.Fragment><br/>
        {location.extras.bemerkung && <div>Bemerkung: {htmr(location.extras.bemerkung)}</div>}
      </React.Fragment>}
      <div className="absolute bottom-1 left-1" >
        {isSelected ?
          <Button className="DeliverySelectBtn" size="small" primary onClick={() => handleSelect( false )} icon={"check"}/> :
          <Button className="DeliverySelectBtn" size="small" basic onClick={() => handleSelect( location )}>{translate( "auswählen" )}</Button>
        }
      </div>
      </div>
      {/*<pre>{JSON.stringify(location, null, 2)}</pre>*/}
    </div>
  )
}

const Adresses = ( {pickUp, locations, locationSelected, onChange, deliveryLocation } ) => {
  let addresses = locations.map( ( location, key ) => {
    // console.log( `${locationSelected} == ${location.mapid}` )
    let isSelected = locationSelected == location.mapid
    if ( isSelected && deliveryLocation && deliveryLocation.mapid ) return null
    return (
      <Fragment key={key}>
      <Responsive maxWidth={789}>
      <Col key={key} sm="2/4"><Card className="DeliveryPageAddresses">
      <Adress pickUp={pickUp} isSelected={isSelected} handleSelect={onChange} location={location}/></Card>
    </Col>
      </Responsive>
      <Responsive minWidth={790}>
      <Col key={key} sm="1/4"><Card className="DeliveryPageAddresses">
      <Adress pickUp={pickUp} isSelected={isSelected} handleSelect={onChange} location={location}/></Card>
    </Col>
      </Responsive>
    </Fragment>)
  } )
  return <Fragment>
    <Responsive maxWidth={789}>
    <Row>
      {deliveryLocation && deliveryLocation.mapid && <Col key="AB" sm="4/4"><Card className="DeliveryPageAddresses">
        <Adress pickUp={pickUp} isSelected={true} handleSelect={onChange} location={deliveryLocation}/></Card>
      </Col>}
      {addresses}</Row>
    </Responsive>
    <Responsive minWidth={790}>
      <Row>
      {deliveryLocation && deliveryLocation.mapid && <Col key="AB" sm="1/4"><Card className="DeliveryPageAddresses">
        <Adress pickUp={pickUp} isSelected={true} handleSelect={onChange} location={deliveryLocation}/></Card>
      </Col>}
      {addresses}</Row>
    </Responsive>
  </Fragment>
}

const TemporaryAddress = ( { onSubmit, temporaryAddress } ) => {
  const [open, setOpen] = React.useState( false )
  const [untouched, setUntouched] = React.useState( true )
  const [address, setAddress] = React.useState( false )
  return <div>
    <Button onClick={() => setOpen( true )}>{translate( "Neue Lieferadresse" )}</Button>
    <Modal open={open}>
      <Modal.Header>
        <div className="flex flex-row justify-between items-center">
          <div>{translate( "Lieferadresse" )}</div>
          <Button basic circular
                  onClick={() => {
                    setOpen( false )
                  }}
                  icon="times"
          />
        </div>
      
      </Modal.Header>
      <Modal.Content>
        <TemporaryAddressForm
          untouched={untouched}
          onChange={( address ) => {
            setAddress( address )
          }}/>
      </Modal.Content>
      <Modal.Actions>
        <Button basic type="link-cancel" onClick={() => setOpen( false )}>{translate( "schließen" )}</Button>
        <Button primary className="fr" onClick={() => {
          setUntouched( false )
          if ( !address.name1 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmen" ) )
          // if ( !address.name2 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmenszusatz" ) )
          if ( !address.street ) return shop.toast( translate( "Bitte ausfüllen: Straße" ) )
          if ( !address.city ) return shop.toast( translate( "Bitte ausfüllen: Stadt" ) )
          if ( !address.pcode ) return shop.toast( translate( "Bitte ausfüllen: Postleitzahl" ) )
          onSubmit( address )
          // TODO: VALIDATE
          setOpen( false )
        }
        } type="primary">{translate( "Adresse auswählen" )}</Button>
      </Modal.Actions>
    </Modal>
  </div>
  
  // return (
  //   <div>
  //     <Modal isOpen={modalOpened} onCancel={() => handleModal( false )} backdropClosesModal>
  //       <ModalHeader text={`Neue Adresse hinzufügen`} onClose={() => handleModal( false )}/>
  //       <ModalBody>
  //         <TemporaryAddressForm handleChange={handleChange} temporaryAddress={temporaryAddress}/>
  //       </ModalBody>
  //       <ModalFooter>
  //         <Button type="link-cancel" onClick={() => handleModal( false )}>schließen</Button>
  //         <Button className="fr" type="primary" onClick={() => handleAddressChoice()}>hinzufügen</Button>
  //       </ModalFooter>
  //     </Modal>
  //
  //     <Row>
  //       <Col sm="1">
  //         <Button className="mt2" onClick={() => handleModal( true )}>temporäre Adresse hinzufügen</Button>
  //       </Col>
  //     </Row>
  //   </div>
  // )
}

const TemporaryAddressForm = ( { onChange, untouched = true, temporaryAddress = {} } ) => {
  const [form, setForm] = React.useState( Object.assign( { extras: { freecontact: "",ILN: "" } }, temporaryAddress ) )
  const handleChange = ( event ) => {
    const name = event.currentTarget.name
    const value = event.currentTarget.value
    const newForm = { ...form, [ name ]: value }
    setForm( newForm )
    onChange && onChange( newForm )
  }
  const handleGLNChange = ( event ) => {
    let glnID = event.target.value
    this.setState( { glnID } )
    shop.cart.setExtra( "glnID", glnID )
  }
  
  return (
    <form className={`AddressForm TemporaryAddressForm ${untouched ? "untouched" : ""}`}>
      <Row>
        <Col sm="1/3">
          <FormField label={translate( "Unternehmen" ) + "*"} htmlFor="name1">
            <FormInput maxLength={50} required type="text" name="name1" value={form.name1} onChange={handleChange}/>
          </FormField>
        </Col>
        
        <Col sm="1/3">
          <FormField label={translate( "Unternehmenszusatz" )} htmlFor="name2">
            <FormInput maxLength={50} type="text" name="name2" value={form.name2} onChange={handleChange}/>
          </FormField>
        </Col>
        
        <Col sm="1/3">
          <FormField label={translate( "Ansprechpartner" )} htmlFor="contact">
            <FormInput maxLength={50} type="text" name="freecontact" value={form.extras.freecontact} onChange={( event ) => {
              const name = event.currentTarget.name
              const value = event.currentTarget.value
              const newForm = { ...form, extras: { ...form.extras, [ name ]: value } }
              setForm( newForm )
              onChange && onChange( newForm )
              console.log( { newForm } )
            }}/>
          </FormField>
        </Col>
      
      </Row>
      {/*<FormField label="Firma" htmlFor="company">*/}
      {/*  <Row>*/}
      {/*    <Col sm="1">*/}
      {/*      <FormInput type="text" name="company" placeholder="Firma" value={form.company}*/}
      {/*                 onChange={handleChange}/>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*</FormField>*/}
      
      <Row>
        <Col sm="1">
          <FormField required label={translate( "Straße" ) + "*"} htmlFor="street">
            <FormInput required maxLength={50} type="text" name="street" placeholder="Straße" value={form.street}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <Row>
        <Col sm="1">
          <FormField label={translate( "Adresszusatz" )} htmlFor="addition">
            <FormInput maxLength={50} type="text" name="addition" placeholder="Adresszusatz"
                       value={form.addition}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <Row>
        <Col sm="1/5">
          <FormField maxLength={20} required label={translate( "PLZ" ) + "*"} htmlFor="pcode">
            <FormInput required type="text" name="pcode" placeholder="PLZ" value={form.pcode}
                       onChange={handleChange}/>
          </FormField>
        </Col>
        <Col sm="4/5">
          <FormField required label={translate( "Ort" ) + "*"} htmlFor="city">
            <FormInput required maxLength={30} type="text" name="city" placeholder={translate("Ort")} value={form.city}
                       onChange={handleChange}/>
          </FormField>
        </Col>
      </Row>
      
      <FormField label="Land" htmlFor="country">
        <Row>
          <Col sm="1">
            <Dropdown
              placeholder="Land"
              fluid
              search
              selection
              options={countryOptions}
              onChange={( e, { value } ) => {
                console.log( { value } )
                let fakeEvent = { currentTarget: { name: "country", value } }
                handleChange( fakeEvent )
              }}
            />
          
          </Col>
        </Row>
      </FormField>
      
      <div className="pt3">
        <p className="f6 black-80">{translate( "Für Rückfragen des Lieferdienstes" )}:</p>
        
        <Row>
          <Col sm="1/5">
            <FormField label="E-Mail" htmlFor="email">
              <FormInput maxLength={50} type="email" name="email" placeholder="E-Mail" value={form.email}
                         onChange={handleChange}/>
            </FormField>
          </Col>
          <Col sm="2/5">
            <FormField label="Telefon" htmlFor="phone">
              <FormInput maxLength={30} type="text" name="phone" placeholder="+49..." value={form.phone}
                         onChange={handleChange}/>
            </FormField>
          </Col>
          <Col sm="2/5">
            <FormField label="GLN" htmlFor="ILN">
              <FormInput maxLength={50} type="text" name="ILN" value={form.extras.ILN} onChange={( event ) => {
                const name = event.currentTarget.name
                const value = event.currentTarget.value
                const newForm = { ...form, extras: { ...form.extras, [ name ]: value } }
                setForm( newForm )
                onChange && onChange( newForm )
                console.log( { newForm } )
              }}/>
            </FormField>
          </Col>
        </Row>
      </div>
    </form>
  )
}


const countryOptions = [
  ["DE", "Deutschland"],
].map( e => ({ key: e[ 0 ], value: e[ 0 ], text: e[ 1 ], flag: e[ 0 ].toLowerCase() }) )


// WEBPACK FOOTER //
// ./src/theme/hvz/pages/checkout/DeliveryPage.js